<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div class="container-fluid">
  <div id="accordion">
    <div class="">
      <div id="headingOne">
        <div class="row_title" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          {{'Usermanagement' | translate}}
          <span>
            <i class="fa" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="card cardCLass">
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="row">
              <div class="col-md-7" style="margin-top:45px;">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group row">
                      <h6 class="col-sm-8" style="padding-top:8px;">{{'Total No of Users' | translate}}</h6>
                      <h3 class="col-sm-2">
                        <span class="badge badge-secondary">{{userCount}}</span>
                      </h3>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group row">
                      <h6 class="col-sm-10" style="padding-top:8px;">{{'Currently Logged In Users' | translate}}</h6>
                      <h3 class="col-sm-2">
                        <span class="badge badge-secondary">{{currentlyLoggedInUsers}}</span>
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group row">
                      <h6 class="col-sm-8" style="padding-top:8px;">{{'Users Never Logged In' | translate}}</h6>
                      <h3 class="col-sm-2">
                        <span class="badge badge-secondary">{{usersNeverLogged}}</span>
                      </h3>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group row">
                      <h6 class="col-sm-8" style="padding-top:8px;">{{'Count of users logged In last 31 days' |
                        translate}}</h6>
                      <h3 class="col-sm-2">
                        <span class="badge badge-secondary">{{usersLoggedInLast31Days}}</span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-offset-8 col-md-5">
                <div style="display: block">
                  <canvas baseChart *ngIf="dataChart != undefined" [datasets]="dataChart" [labels]="labels" [colors]="pieChartColors"
                    [chartType]="pieChartType" [options]="chartOptions"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="text-right pad-rgt-15 pad-tb-20">
        <button type="button" class="btn btn btn-dark" (click)="downloadCSV()">{{'Export' | translate}}</button>
      </div>
      <div class="container-fluid">
        <!-- <div class="ui-widget-header " style="padding:4px 10px;border-bottom: 0 none"> -->
          <!--
            <input #gb type="text" styleClass="Search" pInputText size="80" style="margin:20px; padding:6px;border: 1px solid #ced4da;border-radius: 0.25rem;"
            placeholder="{{'Search your value' | translate}}">
          -->
            <!-- <label for="operationType">{{'Operations Type' | translate}}<span class="required">*</span></label> -->
            
            <!-- <input type="text" (keyup)="onEnter($event)" [(ngModel)]="searchValue" styleClass="Search" pInputText size="80" style="margin:20px 20px 20px 0; padding:6px;border: 1px solid #ced4da;border-radius: 0.25rem;"
            placeholder="{{searchValuePlaceholder}}"> -->
           
        <!-- </div> -->
        <p-table #dt [value]="users" [responsive]="true" [rows]="rowsPerPage" [paginator]="true"  (onLazyLoad)="nextPage($event)" [lazy]="true"
          selectionMode="single" multiViewState="true"  [pageLinks]="3" [rowsPerPageOptions]="[10,20,30]" [totalRecords]="totalRecords"
          [style]="{'margin-bottom': '50px'}">
          <ng-template pTemplate="caption">
            <div class="flex">
              <i class="fa fa-search" style="margin:4px 4px 0 250px"></i>
              <select name="searchValueColumn" style="padding:8px;border: 1px solid #ced4da;border-radius: 0.25rem;margin-right: 5px;" [(ngModel)]="searchValueColumn" (ngModelChange)="setPlaceHolder($event)">
                <option *ngFor="let sv of searchValueList" [value]="sv.value">{{sv.label}}</option>I
              </select>
                <span class="p-input-icon-left ml-auto">
                    <input pInputText type="text" (keyup)="onEnter($event)"  [(ngModel)]="searchValue" styleClass="Search"  size="80" style="margin:20px 20px 20px 0; padding:6px;border: 1px solid #ced4da;border-radius: 0.25rem;" placeholder="{{searchValuePlaceholder}}"/>
                </span>
                <p *ngIf="emptySearchValue" style="text-align: center;color: red;">{{emptySearchValue}}</p>
            </div>
        </ng-template>
          <!-- <p-column class="text-center" field="userName" [style]="{'width':'220px'}" header="{{'User Name' | translate}}"
            [sortable]="true"></p-column>
          <p-column class="text-center" field="roleName" [style]="{'width':'150px'}" header="{{'Role' | translate}}"
            [sortable]="false">
            <ng-template let-row="rowData" pTemplate="body">
              {{getCellDataRoles(row)}}
             </ng-template>
          </p-column>
          <p-column class="text-center" field="supplierCode" [style]="{'width':'150px'}" header="{{'SUPPLIERCODE' | translate}}"
            [sortable]="false">
            <ng-template let-row="rowData" pTemplate="body">
             {{getCellData(row)}}
            </ng-template>
          </p-column>
          <p-column class="text-center" field="firstName" header="{{'First Name' | translate}}" [sortable]="true"></p-column>
          <p-column class="text-center" field="lastName" header="{{'Last Name' | translate}}" [sortable]="true"></p-column>
          <p-column class="text-center" field="companyName" header="{{'Company Name' | translate}}" [sortable]="true"></p-column>
          <p-column class="text-center" field="emailId" [style]="{'width':'260px'}" header="{{'Email Address' | translate}}"
            [sortable]="true"></p-column>
          <p-column class="text-center" field="phone" header="{{'Phone Number' | translate}}" [sortable]="false"></p-column>
          <p-column class="text-center" field="userStatus" header="{{'userMgmtStatus' | translate}}" [sortable]="true"
            [style]="{'width':'100px'}">
            <ng-template let-row="rowData" pTemplate="body">
              <strong [ngStyle]="{'color':row.userStatus === 'Active' ? 'green' : 'red' }">{{row.userStatus |
                titlecase}}</strong>
            </ng-template>
          </p-column> -->
          <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="userName" style="width:20%">{{'User Name' | translate}} <p-sortIcon field="userName"></p-sortIcon></th>
                <th pSortableColumn="roleName">{{'Role' | translate}} <p-sortIcon field="roleName"></p-sortIcon></th>
                <th pSortableColumn="supplierCode" style="width:150px">{{'SUPPLIERCODE' | translate}}<p-sortIcon field="supplierCode"></p-sortIcon></th>
                <th pSortableColumn="firstName" style="width:20%">{{'First Name' | translate}} <p-sortIcon field="firstName"></p-sortIcon></th>
                <th pSortableColumn="lastName" style="width:20%">{{'Last Name' | translate}} <p-sortIcon field="lastName"></p-sortIcon></th>
                <th pSortableColumn="companyName" style="width:20%">{{'Company Name' | translate}} <p-sortIcon field="companyName"></p-sortIcon></th>
                <th pSortableColumn="emailId" style="width:20%">{{'Email Address' | translate}} <p-sortIcon field="emailId"></p-sortIcon></th>
                <th pSortableColumn="phone" style="width:20%">{{'Phone Number' | translate}} <p-sortIcon field="phone"></p-sortIcon></th>
                <th pSortableColumn="userStatus" style="width:20%">{{'userMgmtStatus' | translate}} <p-sortIcon field="userStatus"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value >
            <tr  (click)="rowEdit(value)" >
                <td>{{value.userName}}</td>
                <td>{{getCellDataRoles(value)}}</td>
                <td>{{getCellData(value)}}</td>
                <td>{{value.firstName}}</td>
                <td>{{value.lastName}}</td>
                <td>{{value.companyName}}</td>
                <td>{{value.emailId}}</td>
                <td>{{value.phone}}</td>
                <td>
                  <span  [ngStyle]="{'color':value.userStatus === 'Active' ? 'green' : 'red' }">{{value.userStatus}}</span>
                </td>
            </tr>
        </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <!-- </section> -->